module.exports = __webpack_public_path__ + "img/files.7527957b.svg";